import { DatePipe, CommonModule, NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { LeadEngineerService } from '../../../services/leadengineer.service';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { NotificationService } from '../../../services/notification.service';
import { CommonService } from '../../../services/common.service';
@Component({
    selector: 'app-lead-engineer-compilance-details',
    imports: [FormsModule, DatePipe,   CommonModule, DialogModule, ButtonModule, InputTextModule, CalendarModule, TableModule, SelectButtonModule, DropdownModule, NgIf],
    templateUrl: './lead-engineer-compilance-details.component.html',
    styleUrl: './lead-engineer-compilance-details.component.scss'
})
export class LeadEngineerCompilanceDetailsComponent {
  operationsData: any = [];
  InspectionData: any = {};
  MaximoData: any[] = [];
  EngineeringData: any[] = [];
  EngineeringOGData: any = {};
  userId: string = ''; // Replace with actual user ID
  cssClass: string = '';
  tagNumber: string = '';
  assignedEmail: string = '';
  assignedCAI: string = '';
  leadengineerComment: string = '';
  isUserValid: boolean = false;
  savedLE: boolean = false;
  isLEUpdate: boolean = false;
  isLoading: boolean = false;
  userEmail: string = '';
  userFullName: string = '';
  userCity: string = '';
  userPhone: string = '';
  usersCai: string = '';
  private route = inject(ActivatedRoute);
  constructor(private leadEngineerService: LeadEngineerService, private userService: UserService, private messageService: NotificationService, private commonService: CommonService) {
    this.route.params.subscribe(params => {
      const tagNumber = params['tagNumber'];
      this.tagNumber = tagNumber;
    });
    this.isLoading = true;
  }
  ngOnInit() {
    this.setTableData();
    this.isLoading = true;
    this.savedLE = false;
  }

  setStatus(status: string) {
        status  = status.toUpperCase();
     let returntext = '';
    if (status === 'I') {
      returntext = 'Installed';
    } else if (status === 'P') {
      returntext = 'PreInstalled';
    } else if (status === 'R') {
      returntext = 'Removed';
    }

    return returntext;
  }

  setClass(status: string) {
    status = status.toUpperCase();
    let returnClass = '';
    if (status === 'I') {
      returnClass = 'green';
    } else if (status === 'P') {
      returnClass = 'blue';
    } else if (status === 'R') {
      returnClass = 'red';
    }
    return returnClass;
  }

  getTLRTypeDescription(tlrTypeCode: string): string {
    tlrTypeCode = tlrTypeCode?.toUpperCase() || '';
    const tlrTypeMap: { [key: string]: string } = {
      'A': 'A: Commercial pipe clamp no injection needed',
      'B': 'B: Mechanical enclosures using injectable sealant, composite wraps and wire wraps',
      'C': 'C: Drill and Inject (injection ports)',
      'D': 'D: Welded enclosures, welded patches',
      'E': 'E: Threaded Plugs (ex: Nozzle/repad weephole plug or PRD bellows plug)'
    };
 
    return tlrTypeMap[tlrTypeCode?.toUpperCase()] || tlrTypeCode || '';
  }

  setTableData() {
    this.leadEngineerService.getAssignedData(this.tagNumber).subscribe({
      next: (data: any) => {
        if (data) {
          const operationsOgData = data.Operations[0];
          const InspectionOgData = data.Inspections[0];
          this.EngineeringOGData = data.Engineering[0];
          this.isLEUpdate = data.IsReAssigned;
          this.assignedEmail = data.EmailAddress;
          this.assignedCAI = data.assignedCAI;
          this.operationsData = [
            { key: 'Date Entered Into System', value: this.commonService.formatDateTime(operationsOgData.de_date_entered) || '' },
            { key: 'Operator User ID', value: operationsOgData.de_cai || '' },
            { key: 'TLR Status', value: this.setStatus(operationsOgData.tlr_status) || '',class : this.setClass(operationsOgData.tlr_status) },
            { key: 'Repair Type', value: operationsOgData.repair_type_name || '' },
            { key: 'Tag Number', value: operationsOgData.mx_refnum || '' },
            { key: 'Division', value: operationsOgData.division_name || '' },
            { key: 'Plant', value: operationsOgData.plant_name || '' },
            { key: 'Section', value: operationsOgData.section_name || '' },
            { key: 'Rule 1173', value: operationsOgData.rule_1173 || '' },
            { key: 'Leaking From', value: operationsOgData.leaking_name || '' },
            { key: 'Other Leak Type', value: operationsOgData.leaking_other || '' },
            { key: 'Operating PSI', value: operationsOgData.operating_PSI || '' },
            { key: 'Operating Temp', value: operationsOgData.operating_temperature || '' },
            { key: 'Vapor/Liquid', value: operationsOgData.material_state_name || '' },
            { key: 'Service', value: this.operationsData.service_operations || '' },
            { key: 'Other Service', value: operationsOgData.service_other || '' },
            { key: 'Perm. Repair Completed', value: operationsOgData.mx_assetnum || '' },
            { key: 'Associated Plant - S/D', value: operationsOgData.assoc_plant_shutdown || '' },
            { key: 'Technical Justification ', value: operationsOgData.TechnicalJustification || '' },
            { key: 'Location / Comments', value: operationsOgData.operator_comments || '' },
          ];
          this.MaximoData = [
            { key: 'Reference Number', value: operationsOgData.mx_refnum || '' },
            { key: 'TLR Description', value: operationsOgData.mx_tlr_description || '' },
            { key: 'Description', value: operationsOgData.mx_description || '' },
            { key: 'Work Order Number', value: operationsOgData.mx_wonum || '' },
            { key: 'Work Order Status', value: operationsOgData.mx_wo_status || '' },
            { key: 'Work Order Status Date', value: this.commonService.formatDateTime(operationsOgData.mx_wo_status_date) || '' },
            { key: 'Planner', value: operationsOgData.mx_planner || '' },
            { key: 'Reported By', value: operationsOgData.mx_reportedby || '' },
            { key: 'Report Date', value: this.commonService.formatDateTime(operationsOgData.mx_reportdate) || '' },
            { key: 'Need Date', value: this.commonService.formatDateTime(operationsOgData.mx_needbydate) },
            { key: 'Work Location', value: operationsOgData.mx_worklocation || '' },
            { key: 'Asset Number', value: operationsOgData.mx_assetnum || '' },
            { key: 'Inspector', value:  operationsOgData.mx_legacyid || '' },
            { key: 'Insp. Record Number', value:  operationsOgData.mx_legacyid || '' },
            { key: 'Legacy ID', value: operationsOgData.mx_legacyid || '' },
          ]
          if (this.EngineeringOGData) {
            this.EngineeringData = [
              { key: 'Date Modified ', value: this.commonService.formatDateTime(this.EngineeringOGData.engineering_date) || '' },
              { key: 'Engineer User ID', value: this.EngineeringOGData.engineering_cai || '' },
              { key: 'Engr. Work Order (EWO)', value: this.EngineeringOGData.engineering_work_order || '' },
              { key: 'EWO Completed', value: this.EngineeringOGData.completed == '0' ? 'No' : 'Yes' },
              { key: 'TLR Type', value: this.getTLRTypeDescription(this.EngineeringOGData.TLRType) || '' },
              { key: 'Risk Review', value: this.EngineeringOGData.RiskReview == 'false' ? 'No' : 'Yes' },
              { key: 'Engineer Comments', value: this.EngineeringOGData.engineering_comments || '' },
            ]
          } else {
            this.EngineeringData = [
              { key: 'Date Modified ', value: '' },
              { key: 'Engineer User ID', value: 'No data available' },
              { key: 'Engr. Work Order (EWO)', value: '' },
              { key: 'EWO Completed', value: '' },
              { key: 'TLR Type', value: '' },
              { key: 'Risk Review', value: '' },
              { key: 'Engineer Comments', value: '' },
            ]
          }
          if (InspectionOgData) {
            this.InspectionData = [
              { key: 'Date Modified ', value: this.commonService.formatDateTime(InspectionOgData.inspection_date) || '' },
              { key: 'Inspector User ID', value: InspectionOgData.inspection_cai || '' },
              { key: 'Permanent Repair Date', value: this.commonService.formatDateTime(InspectionOgData.permanent_repair_date) || '' },
              { key: 'Service Class', value: this.serviceCodeLabel(InspectionOgData.ServiceClass) || '' },
              { key: 'Thickness Measure', value: InspectionOgData.thickness_measure || '' },
              { key: 'System Flange Rating  ', value: InspectionOgData.system_flange_rating || '' },
              { key: 'Insp. Plan Comleted', value: InspectionOgData.completed == "1" ? "Yes" : "No" },
              { key: 'Inspector Comments', value: InspectionOgData.inspector_comments || '' },
            ]
          } else {
            this.InspectionData = [
              { key: 'Date Modified ', value: '' },
              { key: 'Inspector User ID', value: 'No data available' },
              { key: 'Permanent Repair Date', value: '' },
              { key: 'Service Class', value: '' },
              { key: 'Thickness Measure', value: '' },
              { key: 'System Flange Rating  ', value: '' },
              { key: 'Insp. Plan Comleted', value: '' },
              { key: 'Inspector Comments', value: '' },
            ]
          }

          this.isLoading = false;
        }
      },
      error: (error: any) => {
        console.error('Error fetching OA data:', error);
      }
    });
  }

  serviceCodeLabel(input: any) {
    let lbl;

    switch (input) {
      case "1":
        lbl = "Class 1: Services with the highest potential of resulting in an immediate emergency if a leak were to occur";
        break;
      case "2":
        lbl = "Class 2: Services not included in other classes";
        break;
      case "3":
        lbl = "Class 3: Services either flammable but do not significantly vaporize when they leak(below the flash point) or flammable but are in remote areas and operate below the boiling point";
        break;
      case "4":
        lbl = "Class 4: Services that are nonflammable and nontoxic are in Class 4, as are most utility services";
        break;
      default:
        lbl = "";
    }

    return lbl;
  }
  validateUser() {
    if (this.userId) {
      this.isLoading = true;
      this.userService.validateLEUser(this.userId).subscribe({
        next: (data: any) => {
          if (data) {
            this.isUserValid = true;
            this.userEmail = data.emailAddress || '';
            this.userFullName = data.displayName || '';
            this.userCity = data.physicalAddressCityName || '';
            this.userPhone = data.ctnNumber || '';
            this.usersCai = data.cai || '';
            this.messageService.showSuccess('User validated successfully!');
          } else {
            this.messageService.showError('Enter Valid User Email');
            this.isUserValid = false;
            this.userEmail = '';
            this.userFullName = '';
            this.userCity = '';
            this.userPhone = '';
            this.usersCai = '';
          }
          this.isLoading = false;
        },
        error: (error: any) => {
          console.error('Error fetching user data:', error);
        }
      });
    }
    // else {
    //   this.messageService.showError('Please enter a valid User ID.');
    // }
  }
  checkFilledData() {
    if (this.isUserValid && this.leadengineerComment != '') {
      return true;
    } else {
      this.messageService.showError('fill the required fields.');
      return false;
    }
  }
  setSavePayload() {
    return ({
      "tagNumber": this.tagNumber,
      "facilityId": this.commonService.getCurrentFacilityId(),
      "engineeringEmail": this.EngineeringOGData?.engineering_cai || '',
      "Email": this.userId,
      "engineeringWorkOrder": this.EngineeringOGData?.engineering_work_order || '',
      "completed": this.EngineeringOGData?.completed == 'No' ? false : true,
      "comments": this.leadengineerComment,
      "tlrType": this.EngineeringOGData?.TLRType || '',
      "riskReview": this.EngineeringOGData?.RiskReview == 'No' ? "false" : "true",
    });
  }
  saveLE() {
    if (this.checkFilledData()) {
      let payload = this.setSavePayload();
      if (this.isLEUpdate) {
        this.leadEngineerService.updateAssignedData(payload).subscribe({
          next: (data: any) => {
            if (data) {
              this.messageService.showSuccess('Lead Engineer saved successfully!');
              this.savedLE = true;

            }
          }
        });
      } else {
        this.leadEngineerService.saveAssignedData(payload).subscribe({
          next: (data: any) => {
            if (data) {
              this.messageService.showSuccess('Lead Engineer saved successfully!');
              this.savedLE = true;

            }
          }
        });
      }
    }
  }
}
